import { DataList, type DataListColumn } from "@/design-system";
import { type ScheduleRow, formatCurrency } from "../utils/finance";

type InstallmentScheduleProps = {
  rows: ScheduleRow[];
};

const COLUMNS: DataListColumn<ScheduleRow>[] = [
  {
    key: "number",
    header: "Parcela",
    primary: true,
    noWrap: true,
    render: row => `Parcela ${row.number}`,
  },
  {
    key: "payment",
    header: "Valor",
    numeric: true,
    noWrap: true,
    render: row => formatCurrency(row.payment),
  },
  {
    key: "interest",
    header: "Juros",
    numeric: true,
    noWrap: true,
    render: row => formatCurrency(row.interest),
  },
  {
    key: "amortization",
    header: "Amortização",
    numeric: true,
    noWrap: true,
    render: row => formatCurrency(row.amortization),
  },
  {
    key: "balance",
    header: "Saldo devedor",
    numeric: true,
    noWrap: true,
    render: row => formatCurrency(row.balance),
  },
];

/** Tabela mês a mês da Price — no celular, um cartão por parcela. */
export const InstallmentSchedule = ({ rows }: InstallmentScheduleProps) => (
  <DataList
    title="Tabela de parcelas"
    caption="Tabela de parcelas do crediário, mês a mês"
    columns={COLUMNS}
    rows={rows}
    rowKey={row => String(row.number)}
  />
);
